import { Text } from "@clipboard-health/ui-components";

import { Button } from "../../../components/Button";
import { PageFooterWrapper } from "../../../components/PageFooterWrapper";
import { InsightContentWrapper } from "../InsightContentWrapper";

interface StartInsightContentProps {
  onNext: () => void;
}

export function StartInsightContent(props: StartInsightContentProps) {
  const { onNext } = props;

  return (
    <>
      <InsightContentWrapper sx={{ gap: 4 }}>
        <Text variant="h1" sx={{ fontSize: "4.75rem", marginTop: 12 }}>
          🎉
        </Text>
        <Text semibold variant="h1" sx={{ fontSize: "4.75rem" }}>
          2025
        </Text>
        <Text variant="h3">Year in review</Text>
        <Text variant="h5" sx={(theme) => ({ color: theme.palette.text.secondary, paddingTop: 4 })}>
          You had a year full of accomplishments! Let&apos;s review some of them...
        </Text>
      </InsightContentWrapper>
      <PageFooterWrapper>
        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();

            onNext();
          }}
        >
          Let&apos;s see!
        </Button>
      </PageFooterWrapper>
    </>
  );
}
